import { c as _c } from "react/compiler-runtime";
import { useProducers } from '@newfront-insurance/admin-ui/accounts';
import { toMap } from '@newfront-insurance/core';
import type { Employee } from '@/api/types/employee';
export interface ProducersMapHook {
  producersMap: Map<string, Employee>;
}
export type FilterField = 'userUuid' | 'uuid';
export function useProducersMap(filterField) {
  const $ = _c(7);
  const {
    data: producers
  } = useProducers();
  let t0;
  if ($[0] !== producers) {
    t0 = producers ?? [];
    $[0] = producers;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== filterField || $[3] !== t0) {
    t1 = mapEmployees(t0, filterField);
    $[2] = filterField;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const producersMap = t1;
  let t2;
  if ($[5] !== producersMap) {
    t2 = {
      producersMap
    };
    $[5] = producersMap;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}
function mapEmployees(employeeList: Employee[], filterField: FilterField = 'userUuid'): Map<string, Employee> {
  return toMap(employeeList, employee => employee[filterField]);
}